import { render } from "./ReintegrosEmbargoPersonaComponent.vue?vue&type=template&id=2e994852"
import script from "./ReintegrosEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./ReintegrosEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__